import { render, staticRenderFns } from "./PaymentSingle.vue?vue&type=template&id=36a5e338"
import script from "./PaymentSingle.vue?vue&type=script&lang=js"
export * from "./PaymentSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports